// THE VR LOOK — buildings (APP_VRSTYLE.md "Buildings"). Every facade texel is its atlas tile's MEAN (the w53
// prefilter's own fade, buildings.js FAC_AA, set so the fade is complete at every footprint — the seam lab's
// `fac-mean` arm): flat wall colours × the baked vertex light, no window grid to alias. Roofs already point at
// the atlas' white tile (flat vertex colour). A uniform value only: no program key moves.
import { FAC_AA } from '../buildings.js';

export function vrsBuildings() {
  FAC_AA.value.set(1, -1, -0.5, FAC_AA.value.w);
}
